import { styled } from '@mui/material/styles';
import { Box, Typography, Link, Chip } from '@mui/material';

/* ───────── container ───────── */

export const WidgetCard = styled(Box)(({ theme }) => ({
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    width:'100%',
    padding: theme.spacing(1),
    marginLeft:'0'
  },
}));

/* ───────── header ───────── */

export const IconBox = styled(Box)(({ theme }) => ({
  height: 40,
  width: 40,
  borderRadius: 8,
  // background: '#45c047',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  color:'white'
}));

export const Header = styled(Typography)({
  fontWeight: 700,
  fontSize: '1.1rem',
});

export const SubHeader = styled(Typography)({
  marginTop: -8,
  color: '#6b7280', // gray-500
  fontSize: '0.85rem',
});

/* ───────── rows ───────── */
export const HeaderRow = styled(Box)({
  display: 'flex',
  flexDirection:'row',
  // justifyContent: 'flex-start',
  alignItems:'center',
  gap:'16px'
});

export const ButtonBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop:'8px'
});

export const StatRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems:'center'
});


export const StatLabel = styled(Typography)({
  fontSize: '0.9rem',
  color: '#333',
  fontWeight:'600'
});

export const StatValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  '&.warn': { color: '#d97706' },   // orange-600
  '&.alert': { color: '#dc2626' },  // red-600
}));

/* ───────── divider & link ───────── */

export const DividerLine = styled(Box)(({ theme }) => ({
  borderTop: '1px solid #e5e7eb', 
  marginTop: theme.spacing(1),
}));

export const DividerLine2 = styled(Box)(({ theme }) => ({
  borderTop: '1px solid #e5e7eb', 
  marginTop: '0px',
}));

export const ActionLink = styled(Link)(({ theme }) => ({
  alignSelf: 'flex-start',
  color: '#2563eb', 
  fontWeight: 600,
  marginTop: theme.spacing(1),
  textDecoration: 'none',
  fontSize: '0.9rem',
  '&:hover': { textDecoration: 'underline' },
}));

// export const BatchesCard = styled(Box)(({ theme }) => ({
//   background: '#fff',
//   borderRadius: 12,
//   boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   padding: theme.spacing(2.5),
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(2),
//   height: 110,
// }));

export const BatchesCard = styled(Box)(({ theme }) => ({
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  padding: theme.spacing(2.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  // desktop
  height: 110,

  // mobile
  [theme.breakpoints.down('sm')]: {
    height: 'auto',           // or 130 / 140 if you want fixed
    padding: theme.spacing(2),
  },
}));
 
export const StockCard = styled(Box)(({ theme }) => ({
  background: 'white',
  borderRadius: 20,
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  padding: '8px 12px',
  display: 'flex',
  flexDirection:'column',
  justifyContent:'center',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  width:'100%',
  margin:'auto',
  height: 110 
}));


// export const TextBlock = styled(Box)({
//   display: 'flex',
//   flexDirection: 'column',
//   width:'50%'
// });

export const TextBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  // default (desktop)
  width: 'auto',

  // mobile only
  [theme.breakpoints.down('sm')]: {
    width: '50%',
  },
}));

export const Label = styled(Typography)({
  fontSize: '0.9rem',
  fontWeight: 600,
  color: '#374151', 
});

export const Value = styled(Typography)({
  fontSize: '1.5rem',
  fontWeight: 700,
  lineHeight: 1.2,
});

export const CardWrap = styled(Box)(({ theme }) => ({
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,.05)',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginBottom:'200px'
  },
}));

/* ——— tabs ——— */
export const TabsBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
  padding: theme.spacing(2, 3, 0),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const TabBtn = styled('button')(({ theme, $active }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  fontWeight: 600,
  color: $active ? theme.palette.primary.main : theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  position: 'relative',
  outline: 'none',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -16,
    left: 0,
    width: '100%',
    height: 2,
    background: $active ? theme.palette.primary.main : 'transparent',
    borderRadius: 2,
  },
}));

export const Badge = styled('span')(({ theme }) => ({
  background: '#fca5a5',
  color: '#fff',
  fontSize: 12,
  fontWeight: 600,
  borderRadius: 12,
  padding: '0 6px',
}));

/* ——— panel ——— */
export const Panel = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  overflowY: 'auto',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  marginBottom: theme.spacing(3),
}));

/* ——— table ——— */
export const TableHead = styled('tr')(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  fontSize: 14,
  '& th': {
    paddingBottom: theme.spacing(1.5),
  },
}));

export const Row = styled('tr')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-child': { border: 'none' },
}));

export const Cell = styled('td')(({ theme, $first }) => ({
  padding: theme.spacing(2, 0),
  verticalAlign: 'middle',
  fontSize: 14,
  '& small': { color: theme.palette.text.secondary, fontSize: 12 },
  ...( $first && {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  }),
}));

/* ——— helpers ——— */
export const Pill = styled('span')(({ theme }) => ({
  background: '#fee2e2',
  color: theme.palette.error.main,
  padding: '2px 10px',
  borderRadius: 20,
  fontSize: 12,
  fontWeight: 600,
}));

export const IconSquare = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  background: '#e0e7ff',
}));

export const ActionBtn = styled('a')(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
}));


export const PromoCard = styled(Box)(({ theme }) => ({
  background: 'white',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  // height: '100%',
}));

export const SearchHeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const IconWrap = styled(Box)(({ theme }) => ({
  width: 44,
  height: 44,
  borderRadius: 10,
  display: 'grid',
  placeItems: 'center',
  background: '#e0f2fe',        // light blue
  fontSize: 20,
}));

export const SearchTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  lineHeight: 1.2,
  textAlign:'left'
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: '#333',
  fontSize: '0.9rem',
  fontWeight:'500',
  textAlign:'left'
}));

export const ChipsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const FeatureChip = styled(Chip)(({ theme }) => ({
  height: 28,
  fontWeight: 600,
  '&.brand': {
    background: '#dcfce7',         // green tint
    color: '#166534',
  },
  '&.generic': {
    background: '#e0e7ff',         // indigo tint
    color: '#3730a3',
  },
  '&.effects': {
    background: '#fee2e2',         // red tint
    color: theme.palette.error.main,
  },
}));

export const CTAButton = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  fontWeight: 700,
  borderRadius: 10,
  padding: theme.spacing(1.25, 2),
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  transition: 'transform 120ms ease, box-shadow 120ms ease',
  '&:hover': {
    textDecoration: 'none',
    transform: 'translateY(-1px)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
  },
}));

export const FooterNote = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.8rem',
}));